/**
 * Created by 86478 on 2017/3/27.
 */
import {
    PackageAdd,
    GetPackageById,
    PackageUpdate
} from '@api/packageApi.js';
import {
    GetParmConfig,
    ParmConfigDel,
    ParmConfigAdd,
    GetProductClass
} from '@api/commonApi.js';
import {
    GetProductByPage
} from '@api/productApi.js';
import NProgress from 'nprogress';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import $http from '$http';
import viewPhoto from 'src/common/js/viewPhoto';

module.exports = {
    data() {
        return {
            /*-----------------------*/
            loading2: false,
            dialog: {
                UnitShow: false,
                ProShow: false,
            },
            dialogTable: {},
            activeNaturalId: "",
            activeSaleId: "",
            dialogContent: "",
            Productindex: "",
            ProductList: [],
            isUpdata: false,
            isView: false,
            isEdit: true,
            activeProductId: "",
            activeProductName: "",
            activeProductUnit: "",
            Category: [{
                Id: "All",
                ParmName: "全部"
            }],
            ProductClass: [{
                Key: "全部",
                Value: "All"
            }],
            /*分页*/
            pageIndex: 1,
            pageSize: 25,
            totalSize: '',
            sels: [], //列表选中列
            /*---*/
            Session: util.getSessin(),
            naturalUnitsList: [],
            saleUnitsList: [],
            StockTypeNames: MAP_LIST.STOCKTYPE_NAME, //仓库类型
            query: {
                ProId: "",
                ProName: "",
                ProClass: "",
                ProAttr: ""
            },
            PackageItem: [{
                "ProId": "",
                "ProNum": "",
                "ProName": "",
                "ProUnit": "",
            }],
            Form: this.submitFormData(),
        }
    },
    methods: {
        // 提交数据
        submitFormData() {
            return cloneDeep({
                ProName: "",
                ProNick: "",
                ProCode: "",
                ProNaturalUnit: "",
                ProSaleUnit: "",
                ProProportion1: "",
                ProProportion2: "",
                ProRemark: "",
                Price: "",
                SalePrice: "",
                List: [],
                StockType: "",
            });
        },
        dialogClosed(num) {
            if (num == "1") {
                this.dialogContent = "";
            } else {
                this.Category = [{
                    Id: "All",
                    ParmName: "全部"
                }];
                this.ProductClass = [{
                    Key: "全部",
                    Value: "All"
                }];
                this.query = {
                    ProId: "",
                    ProName: "",
                    ProClass: "",
                    ProAttr: ""
                };
            }
        },
        pathBack() {
            this.$router.push('/productInformation/packageControl');
        },
        submit() {
            var b = [];
            for (var i = 0; i < this.PackageItem.length; i++) {
                var a = {};
                a.ProId = this.PackageItem[i].ProId;
                a.ProNum = this.PackageItem[i].ProNum;
                b.push(a)
            };
            this.Form.List = b;

            let Params = cloneDeep(this.Form)
            Params.ProNaturalUnit = this.activeNaturalId
            Params.ProSaleUnit = this.activeSaleId
            if (this.isUpdata) {
                Params.ProductId = this.$route.query.Id;
                PackageUpdate(Params).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "修改套餐成功",
                            type: 'success'
                        });
                        this.$router.push('/productInformation/packageControl');
                    });

                })
            } else {
                PackageAdd(Params).then(res => {
                    util.doResult(this, res,
                        () => {
                            this.$notify({
                                title: '成功',
                                message: "添加套餐成功",
                                type: 'success'
                            });
                            this.$router.push('/productInformation/packageControl');
                        }
                    );

                })
            }
        },
        ProductSure() {
            var index = this.Productindex;
            for (var i = 0; i < this.ProductList.length; i++) {
                if (this.ProductList[i].ProductId == this.activeProductId) {
                    this.activeProductName = this.ProductList[i].ProName;
                    this.activeProductUnit = this.ProductList[i].ProNaturalUnitName
                }
            }
            this.PackageItem[index].ProId = this.activeProductId;
            this.PackageItem[index].ProName = this.activeProductName;
            this.PackageItem[index].ProUnit = this.activeProductUnit;
            this.activeProductId = "";
            this.activeProductName = "";
            this.activeProductUnit = "";
            this.dialog.ProShow = false;
            this.Productindex = "";

        },
        getClass: function () {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1]
            };
            GetProductClass(Params).then(res => {
                util.doResult(this, res,
                    () => {
                        for (var i = 0; i < res.data.Data.length; i++) {
                            this.ProductClass.push(res.data.Data[i])
                        }
                    }
                );
            })
        },
        addProduct: function () {
            this.PackageItem.push({
                ProId: "",
                ProNum: "",
                ProName: "",
                ProUnit: ""
            });
        },
        ProductShow(a) {

            this.Productindex = a;
            this.dialog.ProShow = true;
            this.getProList();
            this.getClass();
            this.getSelectList(1);
        },
        getProList() {
            this.ProductList = [];
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            };
            if (this.query.ProId != "") {
                Params.ProCode = this.query.ProId;
            }
            if (this.query.ProName != "") {
                Params.ProName = this.query.ProName;
            }
            if (this.query.ProClass != "" && this.query.ProClass != "All") {
                Params.ProClass = this.query.ProClass;
            }
            if (this.query.ProAttr != "" && this.query.ProAttr != "All") {
                Params.ProCategory = this.query.ProAttr;
            }
            Params.Enable = 0;
            this.loading2 = true;
            GetProductByPage(Params).then(res => {
                this.loading2 = false;
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.totalSize = res.data.Cnt;
                    this.ProductList = res.data.Data;
                }
            })
        },
        UnitDialog(type) {
            this.dialog.UnitShow = true;
            if (type == 6) {
                this.dialogTable = {
                    title: "自然单位管理",
                    data: this.naturalUnitsList,
                    label: "自然单位",
                    type: 6
                };
            };
            if (type == 7) {
                this.dialogTable = {
                    title: "销售单位管理",
                    data: this.saleUnitsList,
                    label: "销售单位",
                    type: 7
                };
            };
        },
        getSelectList(type, isAdd) {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                ParmType: type
            };
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 1) {
                        for (var i = 0; i < res.data.Data.length; i++) {
                            this.Category.push(res.data.Data[i]);
                        }
                    }
                    if (type == 6) {
                        this.naturalUnitsList = res.data.Data;
                        this.dialogTable.data = res.data.Data;
                    };
                    if (type == 7) {
                        this.saleUnitsList = res.data.Data;
                        this.dialogTable.data = res.data.Data;
                    };
                });

                if (isAdd == 1) {
                    if (type == 6) {
                        this.activeNaturalId = this.naturalUnitsList[this.naturalUnitsList.length - 1].Id;
                        for (var i = 0; i < this.naturalUnitsList.length; i++) {
                            if (this.naturalUnitsList[i].Id == this.activeNaturalId) {
                                this.Form.ProNaturalUnit = this.naturalUnitsList[i].ParmName
                            }
                        }
                    };
                    if (type == 7) {
                        this.activeSaleId = this.saleUnitsList[this.saleUnitsList.length - 1].Id;
                        for (var i = 0; i < this.saleUnitsList.length; i++) {
                            if (this.saleUnitsList[i].Id == this.activeSaleId) {
                                this.Form.ProSaleUnit = this.saleUnitsList[i].ParmName
                            }
                        }
                    };
                }
            })
        },
        delTable(index, item, type) {
            let para = {
                Ids: item.Id
            };
            ParmConfigDel(para).then(res => {
                util.doResult(this, res, () => {
                    this.getSelectList(type);
                    this.activeSelect(type, item.Id)
                });

            })
        },
        activeSelect(type, Id) {
            if (type == 6) {
                if (this.naturalUnitsList.length > 0) {
                    for (var i = 0; i < this.naturalUnitsList.length; i++) {
                        if (this.naturalUnitsList[i].Id == Id) {
                            this.Form.ProNaturalUnit = "";
                            this.activeNaturalId = "";
                        }
                    }
                }
            };
            if (type == 7) {
                if (this.saleUnitsList.length > 0) {
                    for (var i = 0; i < this.saleUnitsList.length; i++) {
                        if (this.saleUnitsList[i].Id == Id) {
                            this.Form.ProSaleUnit = "";
                            this.activeSaleId = "";
                        }
                    }
                }
            };
        },
        addDialog(type) {
            var para = {
                ParmType: type,
                ParmName: this.dialogContent
            };
            ParmConfigAdd(para).then(res => {
                util.doResult(this, res, () => {
                    this.dialogContent = "";
                    this.dialog.UnitShow = false;
                    this.getSelectList(type, "1");
                });

            })
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getProList();
        }, //分页选定行
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getProList();
        }, //分页监听页面
        selsChange: function (sels) {
            this.sels = sels;
        },
    },
    watch: {
        activeNaturalId: function () {
            if (this.activeNaturalId !== 0) {
                this.Form.ProNaturalUnit = this.naturalUnitsList.find(item => item.Id == this.activeNaturalId).ParmName
            }

        },
        activeSaleId: function () {
            if (this.activeSaleId !== 0) {
                this.Form.ProSaleUnit = this.saleUnitsList.find(item => item.Id == this.activeSaleId).ParmName
            }
        },
    },
    mounted() {
        this.getSelectList(6); //获取自然单位数组
        this.getSelectList(7); //获取销售单位数组
        if (this.$route.query.Id != undefined) {

            let Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                Id: this.$route.query.Id
            }
            GetPackageById(Params).then(res => {
                util.doResult(this, res, () => {
                    this.Form = res.data.Data;
                    this.activeNaturalId = this.Form.ProNaturalUnit;
                    this.activeSaleId = this.Form.ProSaleUnit;
                    this.PackageItem = this.Form.PackageList;
                    for (var i = 0; i < this.Form.PackageList.length; i++) {
                        this.PackageItem[i].ProId = this.Form.PackageList[i].ProId;
                        this.PackageItem[i].ProNum = this.Form.PackageList[i].ProNum;
                        this.PackageItem[i].ProName = this.Form.PackageList[i].ProName;
                        this.PackageItem[i].ProUnit = this.Form.PackageList[i].ProNaturalUnitName;
                    }
                    if (this.$route.query.view == 1) {
                        this.Form = res.data.Data;
                        this.isView = true;
                        this.$store.dispatch("getRouterName", "查看套餐")
                    } else {
                        this.isUpdata = true;
                        this.$store.dispatch("getRouterName", "修改套餐")
                    }
                });

            })
        } else {
            this.$store.dispatch("getRouterName", "添加套餐")
        }


    }
}


// WEBPACK FOOTER //
// ./src/pages/productInformation/addPackage.js